import axios from 'axios'
import { MessageBox,Message  } from 'element-ui'
import router from '../router/index'; // 确保从正确的路径导入

// 创建 axios 实例
let base = window.location.origin
const request = axios.create({
  // API 请求的默认前缀
  // baseURL: process.env.VUE_APP_API_BASE_URL,//本地
  baseURL: base,//线上
  timeout: 60000, // 请求超时时间
})
console.log(base, 'window.location.host')
// 设置请求头 - tm
function randomStr() {
  const _arr = [
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '0',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
  ]
  const _arr2 = []
  for (let i = 0; i < 20; i++) {
    _arr2.push(_arr[Math.floor(Math.random() * _arr.length)])
  }
  return _arr2.join('')
}
// 异常拦截处理器
const errorHandler = (error) => {
  console.log('3333', error)
  if (error.response) {
    const data = error.response.data
    // 从 localstorage 获取 token
    const token = localStorage.getItem('ACCESS_TOKEN')
    if (error.response.status === 403) {
      console.log('2222')
      return
      // notification.error({
      //   message: 'Forbidden',
      //   description: data.message
      // })
    }
    if (error.response.status === 401) {
      localStorage.clear()
        // window.location.reload()
    }
    if (error.response.status === 500) {
      Message.error(data.message || '服务器错误,请稍后再试');
      return
    }
  }
  return Promise.reject(error)
}

// request interceptor
request.interceptors.request.use((config) => {
  console.log(config, 'config')
  if (typeof config !== 'object' || config === null) {
    throw new TypeError('request config must be an object');
  }
  if (typeof config.headers !== 'object' || config.headers === null) {
    config.headers = {};
  }
  const token = localStorage.getItem('ACCESS_TOKEN')
  const channel = localStorage.getItem('channel')
  const inviteCode = localStorage.getItem('inviteCode')
  console.log(token, 'token')
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  config.headers['tm'] = randomStr()
  console.log(config.headers, 'config.headers')
  config.headers['platform'] = 'WEB'
  config.headers['language'] = 'ja'
  let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  isMobile ? config.headers['platform'] = 'WEB' : config.headers['platform'] = 'WEB'
  // config.headers['channel'] = 'WEB'
  if(channel){
    config.headers['channel'] = channel
  }
  if(inviteCode){
    config.headers['inviteCode'] = inviteCode
  }
config.headers['deviceNumber'] = localStorage.getItem('deviceNumber')
  // config.headers['deviceNumber'] = localStorage.getItem('deviceNumber')
  if (token) {
    config.headers['auth'] = token
  }
  config.headers['Content-Type'] = 'application/json;charset=UTF-8'
  return config
}, errorHandler)

// response interceptor
request.interceptors.response.use((response) => {
  if (typeof response !== 'object' || response === null) {
    throw new TypeError('response must be an object');
  }
  if (typeof response.config !== 'object' || response.config === null) {
    response.config = {};
  }
  if (typeof response.data !== 'object' || response.data === null) {
    response.data = {};
  }
  console.log(response,'respoens')
  // return response.data
  if (response.config.url == '/app/logout') {
    Message.success('退出成功');
    setTimeout(() => {
      Message.closeAll()
    }, 1000)
    return response.data
  } else {
    if (response.data.code === 200) {
      return response.data
    }else if(response.data.code === 300){
      localStorage.clear()
      console.log(router,'this')
      router.push('/mobile_login')
    }  else {
      Message.error(response.data.message || '服务器错误,请稍后再试');
      setTimeout(() => {
        Message.closeAll()
      }, 1000)
      return response.data
    }
  }
}, errorHandler)


export default request

